// extracted by mini-css-extract-plugin
export default {"loader":"LoadingPage_loader__aM4NQ"};